import axios from 'axios'

var http = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {'Content-Type': 'application/json'},
})

var httpupload = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: {'Content-Type': 'multipart/form-data'},
  })

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  if (error.response.status !== 401) return Promise.reject(error)

  var refreshAndRetry = new Promise(function (resolve) {
    axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    },
    {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', JSON.stringify({
        value: response.data.refresh_token,
        expire: null
      }))

      localStorage.setItem('token', JSON.stringify({
        value: response.data.token,
        expire: null
      }))

      return Promise.resolve(response)
    }).then(function (response) {
      var failedRequest = error.config
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      axios.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse)
      })
    })
  })

  return refreshAndRetry
})

function getConfig()
{
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}


// function getContentSectionList (params,callback)
// {
//   var config = getConfig()
//   http.get('/promotion/sections?page='+ params.page, config).then(function(response) {
//     callback({
//       success: true,
//       data: response.data
//     })
//   }).catch(function(error) {
//     callback({
//       success: false,
//       message: error.response.data.message
//     })
//   })
// }
function getContentSectionList(pagination, search, callback) {
  var config = getConfig()

  var url = '/promotion/sections?'

  // if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}

function getContentDetailList(pagination, search, callback) {
  var config = getConfig()

  var url = '/promotion/section-details?'

  if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type
  if (pagination.isbanner !== undefined && pagination.isbanner !== null) url += 'is_banner=true'
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}


function getContentDetailByType(type, callback){
  var config = getConfig()

  var url = '/promotion/sections?type=' + type
  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}

function contentSectionCreate(dataBody, callback)
{
  var config = getConfig()

  http.post('/promotion/section', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}


function deleteContentSection (id, callback) {
  var config = getConfig()

  http.delete('/promotion/section/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}


function contentSectionUpdate(id, data, callback) {
	var config = getConfig()

	http.put('/promotion/section/'+ id, data, config)
		.then(function (response) {
			callback({
				success: true,
				data: response.data
			})
		}).catch(function (error) {
			callback({
				success: false,
				data: error.response.data,
				message: error.response.data.message
			})
		})
}

function createContentDetail(formData, callback) {
  var config = getConfig()
  var param = formData
  config.headers['Content-Type'] = 'multipart/form-data'
  httpupload.post('/promotion/section-detail', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data,
        dd: response
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message,
        dd: error
      })
    })
}

function updateContentDetail (idData, formData, callback) {
  var config = getConfig()
  var param = formData
  config.headers['Content-Type'] = 'multipart/form-data'
  httpupload.put('/promotion/section-detail/'+idData, param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function deleteContentDetail  (id, callback) {
  var config = getConfig()

  http.delete('/promotion/section-detail/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

//=====================VIDEO CONTENT API =======================//
function getContentVideoList(pagination, search, callback) {
  var config = getConfig()

  var url = '/promotion/videos?'

  // if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}

function createContentVideo(formData, callback) {
  var config = getConfig()
  var param = formData
  http.post('/promotion/video', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function updateContentVideo (idData, formData, callback) {
  var config = getConfig()
  var param = formData
  http.put('/promotion/video/'+idData, param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function deleteContentVideo  (id, callback) {
  var config = getConfig()

  http.delete('/promotion/video/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function exportItemBank(data, callback) {
  const ht = axios.create({
    baseURL: process.env.API_BASE_URL,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(localStorage.getItem('token')).value,
      'Accept': 'application/octet-stream'
    }})
  ht.post('/itembank/items/export', data,
  { responseType: 'blob' })
  .then(res => {
    let blob = new Blob([res.data], { type: res.headers['content-type'] });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'itembank_export'+ new Date().getTime()+'.json'
    link.click()
    callback({
      success: true,
      data: response.data
    })
  }).catch(err => {
    callback({
      success: false,
      message: err.message
    })
  })
}




// MENU API ===============================================================

function getMenuList(pagination, search, callback) {
  var config = getConfig()

  var url = '/promotion/menus?'

  // if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}

function menuHomeCreate(dataBody, callback)
{
  var config = getConfig()

  http.post('/promotion/menu', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function updateMenu (idData, formData, callback) {
  var config = getConfig()
  var param = formData
  http.put('/promotion/menu/'+idData, param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function deleteMenu  (id, callback) {
  var config = getConfig()

  http.delete('/promotion/menu/' + id, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}



//================================ BANK SOAL GRATIS aAPI =========================================================================================================

function importItems(dataBody, callback)
{
  var config = getConfig()

  http.post('/promotion/items/bulk-add', dataBody, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function getFreeItems(pagination, callback) {
  var config = getConfig()

  var url = '/promotion/items?mapel=' + pagination.mapelId

  // if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type
  if (pagination.page !== undefined && pagination.page !== null) url += '&page=' + pagination.page
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}
//================================================================================================================================================

// ================================================= GET MENU PREVIEW SETTING ==================================================================

function getMenuPreview(pagination, callback) {
  var config = getConfig()

  var url = '/promotion/menus?'

  if (pagination.status !== undefined && pagination.status !== null) url += 'status=' + pagination.status
  // if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}

function updateMenuSort (formData, callback) {
  var config = getConfig()
  var param = formData
  http.put('/promotion/menu/sort/', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}


// ================================================= GET HOME CONTENT =========================================================================
function getHomeContent(pagination, callback) {
  var config = getConfig()

  var url = '/promotion/section/home-preview?'

  if (pagination.status !== undefined && pagination.status !== null) url += 'status=' + pagination.status
  // if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data,
        message: error.response.data.message
      })
    })
}

function updateSectionSort (formData, callback) {
  var config = getConfig()
  var param = formData
  http.put('/promotion/section/sort', param, config)
    .then(function (response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function (error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function getAllDeeplinks(callback) {
  var config = getConfig()
  var url = '/promotion/deeplinks'
  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.response.data.message
    })
  })
}

/**
 * TOGGLE PUBLISH MENU / SECTION
 */
function togglePublishMenu(id, callback) {
  var config = getConfig()
  var data = {}
  var url = '/promotion/menu/' + id + '/publish'
  http.put(url, data, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.response.data.message
    })
  })
}

function togglePublishSection(id, callback) {
  var config = getConfig()
  var data = {}
  var url = '/promotion/section/' + id + '/publish'
  http.put(url, data, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.response.data.message
    })
  })
}

function getMenuTypes(callback) {
  var config = getConfig()
  var url = '/promotion/types'

  http.get(url, config)
    .then(function(response) {
      callback({
        success: true,
        data: response.data
      })
    }).catch(function(error) {
      callback({
        success: false,
        message: error.response.data.message
      })
    })
}

function getMapels(callback) {
  var config = getConfig()
  var url = '/promotion/mapels'

  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.response.data.message
    })
  })
}

export default
{
  getContentSectionList,
  contentSectionCreate,
  contentSectionUpdate,
  deleteContentSection,
  getContentDetailList,
  createContentDetail,
  deleteContentDetail,
  getContentDetailByType,
  updateContentDetail,
  getContentVideoList,
  createContentVideo,
  updateContentVideo,
  deleteContentVideo,
  exportItemBank,
  menuHomeCreate,
  getMenuList,
  deleteMenu,
  updateMenu,
  importItems,
  getHomeContent,
  getMenuPreview,
  getFreeItems,
  updateMenuSort,
  updateSectionSort,
  getAllDeeplinks,
  togglePublishMenu,
  togglePublishSection,
  getMenuTypes,
  getMapels
}



// WEBPACK FOOTER //
// ./src/services/content.js